import React from 'react';

import { FormControl, Select, MenuItem, Checkbox } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { Close } from '@mui/icons-material';

import { MODALITY_OPTIONS } from '../../constants/observations';

const useStyles = makeStyles((theme) => ({
  '.makeStyles-select .MuiInput-underline:before': {
    border: 'none !important',
  },
  checkbox: {
    padding: 0,
    paddingRight: 8,
  },
  closeIcon: {
    '&:hover': {
      color: '#333',
      cursor: 'pointer',
    },
    color: '#aaa',
    display: 'none !important',
    padding: 2,
    position: 'absolute',
    right: 20,
    top: 4,
  },
  inputContainer: {
    '& .NativeDatepicker, .NativeDatepicker .MuiBox-root, & select': {
      height: 30,
      width: 140,
    },
    '&:hover>.MuiSvgIcon-fontSizeSmall': {
      display: 'block !important',
    },
    position: 'relative',
  },
  list: {
    paddingBottom: 0,
    paddingTop: 0,
  },
  menu: {
    border: '2px solid #E7E7E7',
    borderRadius: 5,
    boxShadow: '2px 6px 10px rgba(0, 0, 0, 0.1)',
    paddingBottom: '1rem',
  },
  menuItem: {
    '&.MuiListItem-root.Mui-selected': {
      backgroundColor: 'white',
    },
    height: 40,
  },
  select: {
    '& .MuiInputBase-input': {
      color: '#999',
      fontFamily: 'Roboto',
      fontSize: 13,
      height: 30,
      padding: '0 5px',
    },
    '&:focus': {
      borderColor: theme.palette.primary.main,
      color: '#444',
      outline: 'none',
    },
    '&:hover': {
      borderColor: theme.palette.primary.main,
      color: '#444',
      cursor: 'pointer',
    },
    border: '1px solid #C8C8C8',
    borderRadius: 8,
    color: '#999',
    height: 30,
    overflow: 'hidden',
    width: 170,
  },
}));

const ModalityMultiSelect = ({ selectedModality = [], onChange, className = '', placeholder = 'Modality', multiple = true }) => {
  const classes = useStyles();

  const renderSelectedModalitiesLabel = (values) => {
    if (!values.length) return placeholder;

    if (values.length === 1) {
      const modality = MODALITY_OPTIONS.find((m) => m.value === values[0]);
      return modality ? modality.label : values[0];
    }

    if (values.length < MODALITY_OPTIONS.length) {
      const firstModality = MODALITY_OPTIONS.find((m) => m.value === values[0]);
      return `${firstModality ? firstModality.label : values[0]} + ${values.length - 1}`;
    }

    return 'All Modalities';
  };

  const handleReset = () => {
    onChange(multiple ? [] : '');
  };

  const handleChange = (event) => {
    onChange(event.target.value);
  };

  if (!multiple) {
    // Single select version for backward compatibility
    return (
      <div className={`${classes.inputContainer} ${className}`}>
        <select
          className={classes.select}
          id="modalitySelect"
          value={selectedModality}
          onChange={handleChange}
          style={{
            '&:hover': {
              borderColor: '#1976d2',
              color: '#444',
              cursor: 'pointer',
            },
            border: '1px solid #C8C8C8',
            borderRadius: 8,
            color: '#999',
            height: 40,
            padding: '0 16px',
            width: '170px !important',
          }}>
          <option value="">{placeholder}</option>
          {MODALITY_OPTIONS.map((modality) => (
            <option key={modality.value} value={modality.value}>
              {modality.label}
            </option>
          ))}
        </select>
        {!!selectedModality && <Close fontSize="small" className={classes.closeIcon} title="Reset Value" onClick={handleReset} />}
      </div>
    );
  }

  return (
    <div className={`${classes.inputContainer} ${className}`}>
      <FormControl className={classes.select}>
        <Select
          id="modalitySelect"
          multiple
          displayEmpty
          value={selectedModality}
          onChange={handleChange}
          renderValue={(val) => renderSelectedModalitiesLabel(val)}
          MenuProps={{
            anchorOrigin: {
              horizontal: 'left',
              vertical: 'bottom',
            },
            classes: {
              list: classes.list,
              paper: classes.menu,
            },
            getContentAnchorEl: null,
          }}>
          {MODALITY_OPTIONS.map((modality) => (
            <MenuItem className={classes.menuItem} key={modality.value} value={modality.value}>
              <Checkbox className={classes.checkbox} checked={selectedModality.indexOf(modality.value) > -1} />
              {modality.label}
            </MenuItem>
          ))}
        </Select>

        {selectedModality.length > 0 && <Close fontSize="small" className={classes.closeIcon} title="Reset Value" onClick={handleReset} />}
      </FormControl>
    </div>
  );
};

export default ModalityMultiSelect;
